import type { FC, CSSProperties } from 'react';

import style from './style.scss';

interface Props {
  size?: number;
  color?: string;
}

function getDotStyle(size: number, color: string | undefined, index: number): CSSProperties {
  return {
    left: size * index * 2,
    width: size,
    height: size,
    backgroundColor: color
  };
}

const Loader: FC<Props> = ({ size = 10, color }) => {
  const loaderStyle = {
    height: size * 2,
    width: size * 5
  };

  return (
    <div className={style.loader} style={loaderStyle}>
      <div className={style.dot} style={getDotStyle(size, color, 0)} />
      <div className={style.dot} style={getDotStyle(size, color, 1)} />
      <div className={style.dot} style={getDotStyle(size, color, 2)} />
    </div>
  );
};

Loader.displayName = 'Loader';

export default Loader;
